import { useContext, useEffect, useState } from 'react';
import AuthContext from '../context/autenticacion/authContext';
import clienteAxios from '../config/axios';
import { fechaCorta, money } from '../components/mercado/utils';
import '../components/mercado/mis.css';
import { useT } from 'i18n';

const EXPLORADOR = 'https://sepolia.etherscan.io';

const corta = (a, vacio) => (a ? `${a.slice(0, 8)}…${a.slice(-6)}` : vacio);

const ESTADO = {
  1: { texto: 'wallet.estCompletada', clase: 'p7-chip-ok' },
  0: { texto: 'wallet.estPendiente', clase: 'p7-chip-wait' },
};

const WalletBlockchain = () => {
  const { t } = useT();
  const { usuario } = useContext(AuthContext);
  const direccion = usuario?.wallet_address || '';
  const alias = usuario?.btoken_username || '';
  const saldo = usuario?.token_balance || 0;
  const clientId = usuario?.id || null;

  const [transfers, setTransfers] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [todas, setTodas] = useState(false);
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    let vivo = true;
    if (!clientId) { setCargando(false); return undefined; }
    clienteAxios.get(`/api/client/transfers/${clientId}`)
      .then((r) => { if (vivo) setTransfers(r.data?.data || []); })
      .catch(() => { if (vivo) setTransfers([]); })
      .finally(() => { if (vivo) setCargando(false); });
    return () => { vivo = false; };
  }, [clientId]);

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(direccion);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 1800);
    } catch (e) { /* sin portapapeles */ }
  };

  const total = transfers.filter((x) => x.status === 1).reduce((s, x) => s + (parseFloat(x.amount) || 0), 0);
  const ok = transfers.filter((x) => x.status === 1).length;
  const espera = transfers.filter((x) => x.status === 0).length;
  const visibles = todas ? transfers : transfers.slice(0, 6);

  return (
    <div className="content">
      <section className="p7x-hero">
        <h2>{t('wallet.titulo')}</h2>
        <p>{t('wallet.subtitulo')}</p>
      </section>

      <div className="p7w">
        <article className="p7w-card" aria-label={t('wallet.tarjetaAria')}>
          <div className="p7w-top">
            <img src={`${process.env.PUBLIC_URL}/panther-gold.svg`} alt="Panther7" />
            <span className="p7w-red">{t('wallet.redPruebas')}</span>
          </div>
          <div className="p7w-saldo">
            <span>{t('wallet.saldo')}</span>
            <strong>${money(saldo)}</strong><em>USDT</em>
          </div>
          <div className="p7w-pie">
            <div>
              <small>{t('wallet.titular')}</small>
              <strong>{alias || t('wallet.sinUsuario')}</strong>
            </div>
            <div>
              <small>{t('wallet.direccion')}</small>
              <div className="p7w-dir">
                <span>{corta(direccion, t('wallet.noAsignada'))}</span>
                {direccion && (
                  <>
                    <button type="button" onClick={copiar}>{copiado ? t('wallet.copiada') : t('wallet.copiar')}</button>
                    <a href={`${EXPLORADOR}/address/${direccion}`} target="_blank" rel="noopener noreferrer">{t('wallet.ver')}</a>
                  </>
                )}
              </div>
            </div>
          </div>
        </article>

        <div className="p7w-stats">
          <div className="p7w-stat ancho"><span>{t('wallet.totalTransferido')}</span><strong>${money(total)}</strong></div>
          <div className="p7w-stat verde"><span>{t('wallet.completadas')}</span><strong>{ok}</strong></div>
          <div className="p7w-stat espera"><span>{t('wallet.pendientes')}</span><strong>{espera}</strong></div>
          <p className="p7w-nota">{t('wallet.nota')}</p>
        </div>
      </div>

      <section className="p7w-hist">
        <header>
          <h3>{t('wallet.historial')}</h3>
          <small>{t('wallet.enTotal', { n: transfers.length })}</small>
        </header>

        {cargando ? (
          <div className="p7x-esq" style={{ minHeight: 140 }} />
        ) : transfers.length === 0 ? (
          <div className="p7x-vacio" style={{ border: 0 }}>
            <h3>{t('wallet.sinTransferencias')}</h3>
            <p>{t('wallet.sinTransferenciasAyuda')}</p>
          </div>
        ) : (
          <>
            <ul className="p7w-lista">
              {visibles.map((tr) => {
                const e = ESTADO[tr.status] || { texto: 'wallet.estFallida', clase: 'p7-chip-bad' };
                return (
                  <li key={tr.id}>
                    <span className="p7w-ico" aria-hidden="true">↗</span>
                    <div>
                      <b>{t('wallet.proyecto', { id: tr.project_id || tr.investment_id })}</b>
                      <small>{tr.to_user ? t('wallet.para', { usuario: tr.to_user }) : ''}{fechaCorta(tr.created_at)}</small>
                      {tr.transaction_hash && (
                        <a href={`${EXPLORADOR}/tx/${tr.transaction_hash}`} target="_blank" rel="noopener noreferrer">{tr.transaction_hash.slice(0, 10)}…</a>
                      )}
                    </div>
                    <div className="p7w-monto">
                      <strong>${money(tr.amount)}</strong>
                      <span className={`p7-chip ${e.clase}`}>{t(e.texto)}</span>
                    </div>
                  </li>
                );
              })}
            </ul>
            {transfers.length > 6 && (
              <div style={{ textAlign: 'center', marginTop: '.8rem' }}>
                <button type="button" className="p7-btn-ghost" onClick={() => setTodas(!todas)}>{todas ? t('wallet.verMenos') : t('wallet.verTodas', { n: transfers.length })}</button>
              </div>
            )}
          </>
        )}
      </section>
    </div>
  );
};

export default WalletBlockchain;
